import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from './constants';

const routes: Routes = [
  {
    path: ROUTES.webinars.base,
    loadChildren: () =>
      import('./modules/webinars/webinars.module').then(
        (m) => m.WebinarsModule,
      ),
  },
  {
    path: ROUTES.error.base,
    loadChildren: () =>
      import('./modules/error/error.module').then((m) => m.ErrorModule),
  },
  {
    path: ROUTES.main.base,
    loadChildren: () =>
      import('./modules/main/main.module').then((m) => m.MainModule),
  },
  { path: '**', redirectTo: `/${ROUTES.error.base}/${ROUTES.error.notFound}` },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
